import defaultMascot from "@/assets/img/Icon_blue.png";
import { resolveBoardIcon } from "@/shared/lib/boardIcon";

/** 現在URLの板slugに対応するヘッダー画像を返す。 */
export function resolveHeaderMascot(slug: string | null): string {
  return resolveBoardIcon(slug) ?? defaultMascot;
}
